import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)
window.Promise = Promise;

const state = {
  history:[],
  startHash:-1,
  moveItem:{},
  selectHash:-1,
  deleteHash:-1,
  activeHash:-1,
  activePreHash:-1,
  activeNextHash:-1,
  activeDirection:'top',
  listPagePars:new Map(),
  addNew:false,
  newProcedure:{
    procedureId: 0,
    procedureName: '',
    procedureNumber: '',
    procedureType: '',
    procedureQuantity: '',
    checkState: false,
    procedureHalfProductId:'',
    procedureHash: '默认下步工序',
    technicsCard:{
      technicsCardId: 0,
      technicsCardTeamsId: '',
      procedureCategoryId: '',
      technicsCardEquipmentIds: [],
      technicsCardIfInStorage: 0,
      technicsCardIfOutsource: 0,
      technicsCardPrice: '',
      technicsCardReferenceTime: '',
      technicsCardSuppliersId: '',
    },
    tcProduceDepictList:[],
    materialsType: 1,
    tcRequiredMaterialsList: [
    ],
    tcBadnessRecordList: [],
    tcQualityPlanList: [
      {
        label:'首检',
        isValid: true,
        tcQualityCheckTypeId: 1,
        tcQualityPlanIfRequire: 1,
        tcQualityPlanDescription: '',
        tcQualityPlanInfo: {
          tcQualityPlanInfoWay: 1,
          tcQualityPlanInfoProportion: '',
          tcQualityPlanInfoIfchecknum: '',
          tcQualityPlanInfoInterval: '',
          qualityCheckPlanIds: [],
          qualityCheckPlanPointsName: '',
          qualityCheckPlanPointsId: '',
          tcQualityPlanPointsList: [],
        },
      },{
        label:'巡检',
        isValid: true,
        tcQualityCheckTypeId: 2,
        tcQualityPlanIfRequire: 0,
        tcQualityPlanDescription: '',
        tcQualityPlanInfo: {
          tcQualityPlanInfoWay: '',
          tcQualityPlanInfoProportion: '',
          tcQualityPlanInfoIfchecknum: '',
          tcQualityPlanInfoInterval: '',
          qualityCheckPlanIds: [],
          qualityCheckPlanPointsName: '',
          qualityCheckPlanPointsId: '',
          tcQualityPlanPointsList: [],
        },
      },{
        label:'末检',
        isValid: true,
        tcQualityCheckTypeId: 3,
        tcQualityPlanIfRequire: 0,
        tcQualityPlanDescription: '',
        tcQualityPlanInfo: {
          tcQualityPlanInfoWay: '',
          tcQualityPlanInfoProportion: '',
          tcQualityPlanInfoIfchecknum: '',
          tcQualityPlanInfoInterval: '',
          qualityCheckPlanIds: [],
          qualityCheckPlanPointsName: '',
          qualityCheckPlanPointsId: '',
          tcQualityPlanPointsList: [],
        },
      },{
        label:'  中检  成品检验',
        isValid: true,
        tcQualityCheckTypeId: 4,
        tcQualityPlanIfRequire: 0,
        tcQualityPlanDescription: '',
        tcQualityPlanInfo: {
          tcQualityPlanInfoWay: '',
          tcQualityPlanInfoProportion: '',
          tcQualityPlanInfoIfchecknum: '',
          tcQualityPlanInfoInterval: '',
          qualityCheckPlanIds: [],
          qualityCheckPlanPointsName: '',
          qualityCheckPlanPointsId: '',
          tcQualityPlanPointsList: [],
        },
      },],

  },
};
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})



// WEBPACK FOOTER //
// ./src/story/index.js